import Vue from "vue";
import Router from "vue-router";

import Home from "@/components/Home";
import Tramite from "@/components/pages/Tramite";
import Solicitud from "@/components/pages/Solicitud";
import Seguimiento from "@/components/pages/Seguimiento";
import Verificar from "@/components/pages/Verificar";
import Contacto from "@/components/pages/Contacto";
import Openid from "@/components/pages/Openid";
import Ppetramite from "@/components/pages/pperedirect";

Vue.use(Router);

const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "Openid",
      component: Openid
    },
    {
      path: "/home",
      name: "Home",
      component: Home
    },
    {
      path: "/tramite",
      name: "Tramite",
      component: Tramite
    },
    {
      path: "/solicitud",
      name: "Solicitud",
      component: Solicitud
    },
    {
      path: "/seguimiento",
      name: "Seguimiento",
      component: Seguimiento
    },
    {
      path: "/verificar/:nro_legalizacion?/:cod_seguridad?/:fecha_expedicion?",
      name: "Verificar",
      component: Verificar
    },
    {
      path: "/contacto",
      name: "Contacto",
      component: Contacto
    },
    {
      path: "/ppe/tramite",
      name: "ppeTramite",
      component: Ppetramite
    }
  ]
});

router.beforeEach((to, from, next) => {
  if (to.name === "Openid" || to.name === "ppeTramite") {
    next();
  } else if (sessionStorage.getItem("legalizacion-web_access_token")) {
    router.app.$serviceoidc
      .postVerificaToken(
        sessionStorage.getItem("legalizacion-web_access_token")
      )
      .then(response => {
        if (response && response.active) {
          console.log("token verificado y correcto");
          return next();
        } else {
          console.log("token inactivo o invalido");
          return next({ name: "Openid" });
        }
      });
  } else {
    next({ name: "Openid" });
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js